import { Component, Input } from '@angular/core';
import { CarrierDTO } from 'src/app/models/CarrierDTO.model';
import { PlanCarrierDTO } from 'src/app/models/PlanCarrierDTO';
import { PlanDTO } from 'src/app/models/PlanDTO.model';
import { PlanTypeDTO } from 'src/app/models/Plans/PlanTypeDTO';
import { ResponseBase } from 'src/app/models/ResponseBase';
import { PlanService } from 'src/app/services/plan.service';
import { carrierConstants } from 'src/app/shared/constants/carrierConstants';
import { MultiSelectItem } from 'src/app/shared/controls/multi-select-control/multi-select-control.component';

import { Alert } from 'src/app/shared/models/Alert';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MultiSelectDropdownComponent } from '../../../shared/controls/multi-select-control/multi-select-control.component';
import { NoWhitespaceDirective } from '../../../directives/no-whitespace.directive';
import { ValidateDecimalsDirective } from '../../../directives/validate-decimals.directive';
@Component({
    selector: 'app-create-plan',
    templateUrl: './create-plan.component.html',
    styleUrls: ['./create-plan.component.css'],
    imports: [
        CommonModule,
        FormsModule,
        MultiSelectDropdownComponent,
        NoWhitespaceDirective,
        ValidateDecimalsDirective
    ]
})
export class CreatePlanComponent {
  title: string = 'Create Plan';
  information: string = '';
  filterValue: string = 'Montly';
  planID: number = 0;
  planName: string = '';
  typeData: string = '';
  qtyData: string = '';
  planTypeId: string = '';
  extraFee?: string = '';
  description: string = '';
  price?: string = '';
  HandleMessage: string = '';
  isUpdate: boolean = false;
  alert: Alert = {} as Alert;
  isActive: boolean = true;

  fieldsCompleted: boolean = false;

  planTypes: PlanTypeDTO[] = [];

  plan: PlanDTO = {
    planName: '',
    price: '',
    planTypeId: '',
    typeData: '',
    extraFee: 0,
    description: '',
    state: 1,
  };

  listOfCarriers: CarrierDTO[] = [];
  // Define the carriers as MultiSelectItem

  carriers: MultiSelectItem[] = [

  ];

  selectedCarriers: string[] = [];

  constructor(
    private planService: PlanService,
    private alertService: AlertService,
    public permissionsService: ValidatePermissionsService
  ) { }

  @Input()
  set getIdPlan(idPlan: number) {
    if (idPlan != undefined) {
      this.loadPlan(idPlan);
    }
  }

  ngOnInit() {
    this.permissionsService.validateAccessLevels(MODULE_ID.Plans);
    this.planService.GetCarriers().subscribe((data: CarrierDTO[]) => {
      // Map the data to MultiSelectItem format
      this.listOfCarriers = data;

      this.carriers = data.map((item: CarrierDTO) => {


        return { id: item.aCarrierId?.toString(), text: item.aCarrierName } as MultiSelectItem;
      });

      this.onSelectionChange(this.selectedCarriers)
    });

    this.planService.GetPlanTypes().subscribe((data: PlanTypeDTO[]) => {
      this.planTypes = data;
    });

  }

  saveChanges() {
    this.plan.planName = this.planName;
    this.plan.typeData = this.typeData.valueOf();
    this.plan.planTypeId = this.planTypeId;
    this.plan.qtyData = parseInt(this.qtyData, 10);
    this.plan.price = this.price != null ? this.price.toString().replace(/[\$,]/g, '').replace(/\,/g, '.') : undefined;
    this.plan.state = this.isActive ? 1 : 0;
    this.plan.extraFee = this.extraFee != null ? parseFloat(this.extraFee.toString().replace(/[\$,]/g, '').replace(/\,/g, '.')) : undefined;
    this.plan.description = this.description;
    this.plan.planCarriers = this.selectedCarriers.map(carrierId => ({
      carrierId: parseInt(carrierId, 10)
    })) as PlanCarrierDTO[];



    if (!this.isUpdate) {
      // Creat
      this.planService.createPlan(this.plan).subscribe(
        (data: ResponseBase) =>
          data != null && data.hasValidationErrors === false
            ? this.handleSaveSuccess(data)
            : this.handleSaveError(0),
        (error) => {
          this.alert = {
            alertMessage: 'Unexpected error. Please try again later.',
            alertType: 'alert alert-danger',
            alertCenter: false,
            alerTitle: '',
            duration: 3000
          };
          this.alertService.updateAlertState(
            this.alert
          );
          this.planName = '';
          this.typeData = '';
          this.qtyData = '';
          this.planTypeId = '';
          this.price = undefined;
          this.extraFee = undefined;
          this.description = '';
        }
      );
    } else {
      // Update
      this.plan.planID = this.planID;
      this.planService.updatePlan(this.plan).subscribe(
        (reponse: ResponseBase) => {
          this.handleSaveSuccess(reponse);
        }

        ,
        (error) => {
          this.alert = {
            alertMessage: 'Unexpected error. Please try again later.',
            alertType: 'alert alert-danger',
            alertCenter: false,
            alerTitle: '',
            duration: 3000
          };
          localStorage.setItem('AlertObject', JSON.stringify(this.alert));
          this.alertService.updateAlertState(
            this.alert
          );
        }
      );
    }
  }

  checkFields() {
    if (
      this.planName &&
      this.typeData &&
      this.qtyData &&
      this.planTypeId &&
      this.price
    ) {
      this.fieldsCompleted = true;
    } else {
      this.fieldsCompleted = false;
    }
  }

  //Este metodo se ejecuta cuando se presiona el boton de regresar
  goBack() {
    //Se redirecciona a la ruta /home
    window.location.href = '/plans';
  }

  handleSaveError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
    this.planName = '';
    this.typeData = '';
    this.planTypeId = '';
    this.price = undefined;
    this.extraFee = undefined;
    this.description = '';
  }

  async handleSaveSuccess(reponse: ResponseBase) {

    this.alertService.success(
      'Plan saved successfully'
    );

    this.planName = '';
    this.typeData = '';
    this.planTypeId = '';
    this.qtyData = '';
    this.price = undefined;
    this.extraFee = undefined;
    this.description = '';
    location.reload();
  }



  onSelectionChange(selectedItems: string[]): void {

    
    this.listOfCarriers;

    //const filteredList = [...originalList];

    // Check if the selected item has ID 3
var carrier = this.listOfCarriers.filter(item => {
  const carrierIdStr = item.aCarrierId?.toString();
  return carrierIdStr !== undefined && selectedItems.includes(carrierIdStr);
}).find(item => item.aCarrierName === carrierConstants.msim);

    if (selectedItems.length !== 0) {
      var carrier = this.listOfCarriers.find(item => item.aCarrierId === parseInt(selectedItems[0]));

      //const isSelectedItem3 = selectedItem && selectedItem.carrierId === 3;

      if (carrier && carrier.aCarrierName === "MSIM") {

        this.carriers = this.listOfCarriers.filter(item => item.aCarrierName === "MSIM").map((item: CarrierDTO) => {
          return { id: item.aCarrierId?.toString(), text: item.aCarrierName } as MultiSelectItem;
        });


      }
      else {
        this.carriers = this.listOfCarriers.filter(item => item.aCarrierName !== "MSIM").map((item: CarrierDTO) => {
          return { id: item.aCarrierId?.toString(), text: item.aCarrierName } as MultiSelectItem;
        });
      }
    }

    else  {
      this.carriers = this.listOfCarriers.map((item: CarrierDTO) => {
        return { id: item.aCarrierId?.toString(), text: item.aCarrierName } as MultiSelectItem;
      });

    }




    this.selectedCarriers = selectedItems;
  }

  getCarrierName(carrierId: string): string {
    return this.carriers.find(c => c.id === carrierId)?.text || carrierId;
  }

  loadPlan(idPlan: number) {
    this.isUpdate = true;
    this.title = 'Update Plan';
    this.information = 'Plan ID ' + idPlan;
    this.planService.getPlanById(idPlan).subscribe(
      (a: PlanDTO) => {
        
        this.HandleGetPlan(a);

      },
      (error) => {
        console.error('Unexpected error fetching customer list:', error);
      }
    );
  }

  HandleGetPlanError(StatusCode: number) {
    this.HandleMessage = 'Unexpected error';
  }

  HandleGetPlan(plan: PlanDTO) {
    console.log(plan);
    const data = plan;

    this.planID = data.planID ?? 0;
    this.planName = data.planName ?? 'N/A';
    this.price = data.price ? `$ ${Number(data.price).toString()}` : "$ 0.00";
    this.description = data.description ?? '';
    this.extraFee = data.extraFee ? `$ ${Number(data.extraFee).toFixed(2)}` : "$ 0.00";
    this.qtyData = data.qtyData ? data.qtyData.toString() : '0';
    this.typeData = data.typeData ?? '';
    this.planTypeId = data.planTypeId ?? 'Unknown';
    this.isActive = data.state === 1;


    this.selectedCarriers = data.planCarriers?.map(carrier => carrier.carrierId.toString()) || [];

    
    this.checkFields();
  }
}
